import ComparisonBlogForm from "../ComparisonBlogForm";

const ComparisonBlogCreate = () => {
  return <ComparisonBlogForm isEditMode={false} />;
};

export default ComparisonBlogCreate;
